module.exports = __webpack_public_path__ + "img/financeiro-thumb.0f040970.jpg";